/**
 * MEWS Image Navigation — Photo carousel within product cards
 * Cycles through stacked product images on arrow click.
 * Works in: editorial carousel, related products, collection grid.
 */

(function () {
  'use strict';

  /**
   * Get the active image index in a nav container.
   * @param {HTMLElement} container - Element with [data-mews-img-nav]
   * @returns {number}
   */
  function getActiveIndex(container) {
    const imgs = container.querySelectorAll('img[data-img-index]');
    for (let i = 0; i < imgs.length; i++) {
      if (parseFloat(imgs[i].style.opacity) > 0.5) return i;
    }
    return 0;
  }

  /**
   * Show image at given index, hide others.
   * @param {HTMLElement} container
   * @param {number} index
   */
  function showImage(container, index) {
    const imgs = container.querySelectorAll('img[data-img-index]');
    if (!imgs.length) return;
    const total = imgs.length;
    const target = ((index % total) + total) % total;
    imgs.forEach(function (img, i) {
      img.style.opacity = i === target ? '1' : '0';
    });
  }

  /**
   * Navigate to previous image.
   * Called from inline onclick="mewsImgPrev(this, event)"
   * @param {HTMLElement} btn - The button element
   * @param {Event} e
   */
  window.mewsImgPrev = function (btn, e) {
    e.preventDefault();
    e.stopPropagation();
    const container = btn.closest('[data-mews-img-nav]');
    if (!container) return;
    showImage(container, getActiveIndex(container) - 1);
  };

  /**
   * Navigate to next image.
   * Called from inline onclick="mewsImgNext(this, event)"
   * @param {HTMLElement} btn - The button element
   * @param {Event} e
   */
  window.mewsImgNext = function (btn, e) {
    e.preventDefault();
    e.stopPropagation();
    const container = btn.closest('[data-mews-img-nav]');
    if (!container) return;
    showImage(container, getActiveIndex(container) + 1);
  };

  /**
   * Also handle touch/swipe on mobile for [data-mews-img-nav] containers.
   */
  function initSwipe(container) {
    var startX = 0;
    container.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    container.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        showImage(container, getActiveIndex(container) + (diff > 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  // Initialize swipe on all current and future img nav containers
  function initAll() {
    document.querySelectorAll('[data-mews-img-nav]').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on dynamic content (e.g. after Shopify section renders or infinite scroll)
  document.addEventListener('shopify:section:load', initAll);
})();
